import { render, staticRenderFns } from "./TransactionsSidebar.vue?vue&type=template&id=007786a4"
import script from "./TransactionsSidebar.vue?vue&type=script&lang=js"
export * from "./TransactionsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports